import { Divider } from "@mui/material";
import localize from "../../../../common/localize";

export default function SignatureBox({
  title,
  subtitle,
  imageBlob,
  widthValue,
}) {
  return (
    <div
      className="flex flex-col report_signature_box"
      style={{ width: widthValue ?? "50%", justifyContent: "space-between" }}
    >
      <div
        style={{
          borderBottomStyle: "solid",
          borderBottomColor: "black",
          borderBottomWidth: "1px",
          height: "30px",
          backgroundColor: "#10366E",
          padding: "2px",
        }}
      >
        <label
          className="report_footer_text"
          style={{ marginLeft: "5px", color: "white" }}
        >
          {title}
        </label>
      </div>

      <div
        className="w-full"
        style={{ display: "flex", flexDirection: "column-reverse" }}
      >
        {subtitle && (
          <div className="flex flex-col">
            <Divider
              style={{
                marginLeft: "5px",
                marginRight: "5px",
                backgroundColor: "black",
              }}
            />

            <label style={{ margin: "5px" }} className="report_footer_text">
              {subtitle}
            </label>
          </div>
        )}
        {imageBlob && (
          <div className="signature_image_box">
            <img
              src={imageBlob}
              alt={localize.field_type_signature}
              style={{
                width: "165px",
                height: "65px",
                alignSelf: "center",
                marginTop: "5px",
                marginLeft: '2px'
              }}
            />
          </div>
        )}
      </div>
    </div>
  );
}
